// extracted by mini-css-extract-plugin
module.exports = {"sliderVerificationModal":"style_sliderVerificationModal__e0P9y","tip":"style_tip__r_TC3"};